import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { Redirect } from 'react-router';

import { EFormState } from '@feathr/blackbox';
import { useIdParams } from '@feathr/extender/hooks';
import { useLocalUrl } from '@feathr/extender/state';
import { DonationFormReport } from '@feathr/report_components';

import Page from '../Page';

function DonationFormReportPage(): JSX.Element {
  const form = useIdParams('donationForm');
  const localUrl = useLocalUrl();

  // Only Published forms have report data worth showing; bounce others to the editor.
  if (!form.isPending && form.get('state') !== EFormState.Published) {
    return <Redirect to={localUrl(form.getItemUrl('edit'))} />;
  }

  return (
    <Page collapseHeader={true} loading={form.isPending} title={form.name}>
      <DonationFormReport form={form} localUrl={localUrl} />
    </Page>
  );
}

export default observer(DonationFormReportPage);
